import React from 'react';
import ReportViewer from "./base/ReportViewer";

const ListeItemsVendus = () => {

    return (
        <div style={{ height: "100%" }}>
            <ReportViewer reportName={"ListeItemsVendusReport"} />
        </div>
    );
}
export default ListeItemsVendus;